// Tactical — sidebar de frentes + painel nativo (Recharts) por frente.
// SEO e Mídia paga ficam pendentes até integrações chegarem.
import { useParams, useSearchParams } from "react-router-dom";
import { FinanceiroPanel } from "./tactical/Financeiro.tsx";
import { ConversaoPanel } from "./tactical/Conversao.tsx";
import { RecompraPanel } from "./tactical/Recompra.tsx";
import { CatalogoPanel } from "./tactical/Catalogo.tsx";
import { SeoPanel } from "./tactical/Seo.tsx";

const FRONTS = [
  { key: "financeiro", label: "Financeiro" },
  { key: "conversao",  label: "Conversão" },
  { key: "recompra",   label: "Recompra" },
  { key: "catalogo",   label: "Catálogo" },
  { key: "seo",        label: "SEO" },
  { key: "midia",      label: "Mídia paga" },
] as const;

const PENDING_REASON: Record<string, string> = {
  midia: "Depende das integrações Google Ads + Meta Ads — ainda não conectadas. Configurar em Integrações.",
};

export function TacticalPage() {
  const { slug } = useParams<{ slug: string }>();
  const [params, setParams] = useSearchParams();
  const front = params.get("front") ?? "financeiro";

  return (
    <>
      <div className="section-head">
        <div>
          <p className="eyebrow">Tático · {FRONTS.find((f) => f.key === front)?.label}</p>
          <h1>Frentes do plano</h1>
        </div>
      </div>

      <div className="tactical">
        <aside className="side">
          {FRONTS.map((f) => {
            const pending = f.key === "midia";
            return (
              <a
                key={f.key}
                href="#"
                className={f.key === front ? "active" : ""}
                onClick={(e) => { e.preventDefault(); setParams({ front: f.key }); }}
              >
                {f.label}
                {pending && (
                  <span style={{ float: "right", fontSize: ".7rem", opacity: .55 }}>•</span>
                )}
              </a>
            );
          })}
        </aside>
        <div>
          {slug && front === "financeiro" && <FinanceiroPanel slug={slug} />}
          {slug && front === "conversao"  && <ConversaoPanel  slug={slug} />}
          {slug && front === "recompra"   && <RecompraPanel   slug={slug} />}
          {slug && front === "catalogo"   && <CatalogoPanel   slug={slug} />}
          {slug && front === "seo"        && <SeoPanel        slug={slug} />}
          {front === "midia" && (
            <div className="card">
              <p className="eyebrow">Aguardando integração</p>
              <h3 style={{ marginTop: ".25rem" }}>
                {FRONTS.find((f) => f.key === front)?.label} ainda sem fonte de dados
              </h3>
              <p style={{ color: "var(--text-soft)", fontSize: ".9rem", marginTop: ".5rem" }}>
                {PENDING_REASON[front]}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
